__turbopack_context__.v({
  "content": "VWFSModal-module-scss-module__CZVpgG__content",
  "makeColumn": "VWFSModal-module-scss-module__CZVpgG__makeColumn",
  "makes": "VWFSModal-module-scss-module__CZVpgG__makes",
  "makesList": "VWFSModal-module-scss-module__CZVpgG__makesList",
  "text": "VWFSModal-module-scss-module__CZVpgG__text",
});
